<script setup>
import InformationIcon from './InformationIcon';

/* eslint-disable vue/no-v-html */

const props = defineProps({
  selectorId: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  placement: {
    type: String,
    default: 'top',
  },
  iconStyle: {
    type: Object,
    default: () => {},
  },
});

</script>

<template>
  <sdds-tooltip
    :placement="props.placement"
    :selector="`#${props.selectorId}`"
    mouse-over-tooltip="true"
    class="sdds-u-textalign-start"
  >
    <div
      class="tooltip-container"
      v-html="props.text"
    />
  </sdds-tooltip>
  <InformationIcon
    :id="props.selectorId"
    :view-box-style="props.iconStyle"
  />
</template>

<style scoped>
  .tooltip-container {
    max-width: 320px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
</style>
